import { CurrentDashboardProfileContext } from '@rma/dashboard/authentication/public/user';
import { CurrentSubscription } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { UserChatData } from '@rma/dashboard/generic/api/chat-data';
import { ChameleonCompany } from '@rma/dashboard/generic/util/chameleon';
import { DcTenantCode } from '@rma/generic/core/instance';
import { differenceInDays } from 'date-fns';

export function buildChameleonCompany(
  tenant: DcTenantCode,
  profile: CurrentDashboardProfileContext,
  subscription: CurrentSubscription | null,
  userChatData: UserChatData,
): ChameleonCompany {
  return {
    uid: `${tenant}-${profile.profileType}-${profile.profileCode}`,
    rma_profile_type: profile.profileType,
    rma_profile_code: profile.profileCode,
    rma_office_name: profile.parentName ?? null,
    rma_plan_status: subscription?.status ?? null,
    rma_plan_name: subscription?.name ?? null,
    // Chat/Data is user-scoped on the backend, not profile-scoped — these fields hold the
    // same values regardless of which profile is active, and don't re-fetch on profile switch.
    rma_plan_tier: userChatData.rma_subscription_tier,
    rma_locale: userChatData.rma_locale,
    rma_customer_age: userChatData.rma_claimed_at ? differenceInDays(new Date(), userChatData.rma_claimed_at) : null,
    rma_is_award_winner: userChatData.rma_is_award_winner,
    rma_has_legacy_social_media_connections: userChatData.rma_has_social_media_connections,
    rma_has_easy_reviews_enabled: userChatData.rma_has_easy_reviews_enabled,
    rma_12month_sales_count: userChatData.rma_12month_sales_count,
    rma_30day_sales_count: userChatData.rma_30day_sales_count,
    rma_30day_review_requests_count: userChatData.rma_30day_review_requests_count,
  };
}
